import { t } from 'i18next';

import { useThemeContext } from '../../context/Theme';

import { useMarketsContext } from './MarketContext';

import { Button, Icon, ToggleButton } from '../UI';

import { MarketFilter } from './types';

export const MarketsFilter = () => {
  const { theme } = useThemeContext();

  const {
    filterFavourites,
    filterMerlin,
    filterPortfolio,
    isMarketFilterVisible,
    noActiveFilter,
    resetFilters,
    toggle,
  } = useMarketsContext();

  const filters = Object.entries({
    filterFavourites,
    filterPortfolio,
    filterMerlin,
  }) as [MarketFilter, boolean][];

  return (
    <div
      className={`
        flex
        flex-col
        gap-2
        absolute
        bg-white
        h-36
        w-60
        right-1
        -bottom-36
        rounded-lg
        p-2
        border
        border-grey-10
        shadow-strong
        ${!isMarketFilterVisible && 'invisible'}
      `}
    >
      <div className="flex items-center">
        <Button
          type="button"
          variant="secondary"
          onClick={resetFilters}
          disabled={noActiveFilter}
        >
          <span className="capitalize-first dark:text-white">
            {t('common.reset')}
          </span>
        </Button>
        <Icon
          svgName="close"
          className={`ml-auto h-3 w-3 mt-0.5 cursor-pointer${
            theme === 'DARK' ? ' filter invert' : ''
          }`}
          onClick={() => toggle('isMarketFilterVisible')}
        />
      </div>

      {filters.map(([filter, value], i) => (
        <div
          key={filter}
          className="flex text-sm cursor-pointer hover:bg-grey-5 px-2"
        >
          <span className="mr-auto dark:text-black">
            {t(`markets.filters.${i}`)}
          </span>
          <ToggleButton
            onActivate={() => toggle(filter)}
            onDeactivate={() => toggle(filter)}
            isActivated={value}
          />
        </div>
      ))}
    </div>
  );
};
